import {Component, inject} from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import { ActionCardPreviewComponent } from 'shared-lib';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {CampaignsListComponentComponent} from '../campaigns-list-component.component';
import {CampaignsWithoutLoyaltyStore} from '../../../../store/paged-campaigns.store';

@Component({
    selector: 'app-campaign-without-loyalty-list',
    templateUrl: '../campaigns-list-component.component.html',
    styleUrl: '../campaigns-list-component.component.scss',
    imports: [ActionCardPreviewComponent, MatProgressSpinner]
})
export class CampaignsWithoutLoyaltyListComponent extends CampaignsListComponentComponent {
  private activeCampaignsStore = inject(CampaignsWithoutLoyaltyStore);

  constructor(bottomSheet: MatBottomSheet) {
    super(bottomSheet)
  }

  protected override getStore = () => this.activeCampaignsStore;
}

